import { render, staticRenderFns } from "./PreferencesDialog.vue?vue&type=template&id=476ed204"
import script from "./PreferencesDialog.vue?vue&type=script&lang=ts"
export * from "./PreferencesDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports